import React from "react";
import { useQuery } from "@apollo/client";

const Query = ({ children, query, slug }) => {
  const { data, loading, error } = useQuery(query, {
    variables: { slug: slug },
  });

  if (loading)
    return (
      <body scroll="no" className="overflow-hidden ">
        <div class="flex justify-center w-full items-center fixed overflow-hidden  bg-white  z-50 left-0 right-0 bottom-0 top-0">
          <div class="animate-spin rounded-full h-32 w-32 border-b-2 border-main-color"></div>
        </div>
      </body>
    );
  if (error) return <p>Error: {JSON.stringify(error)}</p>;
  return children({ data });
};

export default Query;
